import * as qs from 'query-string';

export class Elastic {
  static base = '/go/api/v1';
  static defaultSearchSize = 120;

  static getUrl(model, path, params) {
    return `${this.base}/${model}/${path}?${qs.stringify(params)}`;
  }

  static formatResults(json) {
    const res = { total: 0, hits: [] };
    
    if (!!json && !!json.hits && !!json.hits.hits.length) {
      res.total = json.hits.total;
      res.hits = json.hits.hits.map(h => h._source);
    }

    return res;
  }

  static async searchInstruments(q) {
    const params = {
      q: q,
      size: 500,
      sort: 'instrument.name'
    };
    const url = this.getUrl('instruments', 'search', params);
    const result = await fetch(url);
    const json = await result.json();
    return this.formatResults(json);
  }

  static async searchVoiceTypes(q) {
    const params = {
      q: q, 
      size: 500,
      sort: 'name'
    };
    const url = this.getUrl('voice-types', 'search', params);
    const result = await fetch(url);
    const json = await result.json();
    return this.formatResults(json);
  }
};
